import { render, staticRenderFns } from "./moreHomomorphic.vue?vue&type=template&id=95b11cd4&scoped=true&"
import script from "./moreHomomorphic.vue?vue&type=script&lang=js&"
export * from "./moreHomomorphic.vue?vue&type=script&lang=js&"
import style0 from "./moreHomomorphic.vue?vue&type=style&index=0&id=95b11cd4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95b11cd4",
  null
  
)

export default component.exports